export const LogoMark = ({ className = "h-10 w-10", dark = false }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill={dark ? "#F8F6F0" : "#1E1B18"} />
    <path d="M12 30 L32 13 L52 30" fill="none" stroke="#C85A32" strokeWidth="5" strokeLinecap="square" />
    <path d="M38 26 V42 a8 8 0 0 1 -16 0" fill="none" stroke={dark ? "#1E1B18" : "#F8F6F0"} strokeWidth="5" strokeLinecap="square" />
    <rect x="18" y="50" width="28" height="3" fill="#D49A46" />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark dark={dark} />
    <span className="leading-none">
      <span className={`block font-serif-d text-xl font-semibold tracking-tight ${dark ? "text-[#FAF9F5]" : "text-[#1E1B18]"}`}>
        James Family
      </span>
      <span className={`block font-mono-d text-[10px] uppercase tracking-[0.28em] mt-1 ${dark ? "text-[#D8D2C8]" : "text-[#605A52]"}`}>
        Home Improvement LLC
      </span>
    </span>
  </span>
);
